import { render, staticRenderFns } from "./DeleteMasterFromGroupClassConfirmationDialog.vue?vue&type=template&id=38b0a0cd"
import script from "./DeleteMasterFromGroupClassConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMasterFromGroupClassConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports